import * as React from 'react';
import styled from 'styled-components';
import MuiPopover, { PopoverProps as MuiPopoverProps } from '@material-ui/core/Popover';

const StyledPopover = styled(MuiPopover)``;

export type DSPopoverProps = MuiPopoverProps;
export const DSPopover: React.FC<DSPopoverProps> = StyledPopover;
